import CerealVolcadora from '../../../models/volcadora/cereal_volcadora'
import DemoraVolcadora from '../../../models/volcadora/demora_volcadora'
import Volcadora from '../../../models/volcadora/volcadora'

export function cerealAsignadoVolcadora () {
  return (dispatch) => {
    CerealVolcadora.getCerealAsignadoVolcadoras()
      .then(resultado => {
        dispatch({
          type: 'RECEIVE_VOLCADORA_CEREAL_ASIGNADO',
          resultado })
      })
  }
}

export function obtenerVolcadorasConCerealAsignado () {
  return (dispatch) => {
    Volcadora.getVolcadorasConCerealAsignado()
      .then(data => {
        dispatch({ type: 'RECEIVE_VOLCADORA_CON_CEREAL_ASIGNADO', data })
      })
  }
}

export function cerealVolcadoraOriginal () {
  return (dispatch) => {
    CerealVolcadora.getCerealVolcadorasOriginal()
      .then(resultado => {
        dispatch({
          type: 'RECEIVE_VOLCADORA_CEREAL_ORIGINAL',
          resultado })
      })
  }
}

export function setVolcadoraCamiones (volcadora) {
  return dispatch => {
    dispatch({ type: 'SET_CEREAL_ESPECIE', volcadora })
  }
}

export function requestVolcadoraCamiones () {
  return dispatch => {
    dispatch({ type: 'REQUEST_VOLCADORA_CAMIONES' })
    return Volcadora.getVolcadorasCamiones()
      .then(volcadorasCamiones => {
        dispatch({
          type: 'RECEIVE_VOLCADORA_CAMIONES',
          volcadorasCamiones })
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_VOLCADORA_CAMIONES',
        volcadorasCamiones: []
      }))
  }
}

export function getCallesVolcadora () {
  return (dispatch) => {
    return Volcadora.getCallesVolcadoras()
      .then((calleDeVolcadora) => {
        dispatch({ type: 'CALLE_DE_VOLCADORA', calleDeVolcadora })
      })
  }
}

export function updateHabilitacionCalleDeVolcadora (calle, habilitado) {
  return (dispatch) => {
    return Volcadora.updateHabilitacionCalleDeVolcadora(calle, habilitado)
      .then((response) => {
        dispatch({ type: 'UPDATE_HABILITADO_CALLE_VOLCADORA' })
        dispatch(getCallesVolcadora())
      })
  }
}

export function getMotivosVolcadora () {
  return (dispatch) => {
    return DemoraVolcadora.getMotivosDeDemoraEnVolcadora()
      .then((result) => {
        if (!result.error) {
          const motivos = result.data
          dispatch({ type: 'RECEIVE_MOTIVOS_DEMORA_VOLCADORA', motivos })
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }
}
